/**
 * Affiliate URLs for estate document creation services.
 *
 * These are used in the new onboarding wizard (Phase 1+) when a user
 * says "no" to having a Will/Trust/Advance Directive/POA. We offer to
 * help them create one via LegalZoom and track the click as an
 * affiliate referral.
 *
 * PLACEHOLDERS: the real affiliate URLs will be swapped in once the
 * LegalZoom affiliate application is approved. Until then every
 * estate-doc branch routes to the generic MyFinalKey landing page so
 * users don't hit a broken link in the meantime.
 *
 * When the real URLs arrive:
 *   1. Replace each placeholder below
 *   2. If LegalZoom provides a single affiliate URL rather than per-doc
 *      deep links, point all four constants at the same URL
 *   3. No code changes needed elsewhere — callers import by doc type
 *
 * Click tracking: any caller that opens one of these URLs should fire
 * AnalyticsEvent.LegalZoomAffiliateClicked with { doc_type } so we can
 * attribute referral revenue per doc type.
 */

const PLACEHOLDER_FALLBACK = 'https://www.myfinalkey.com/estate-planning';

export type EstateDocType = 'will' | 'trust' | 'advance_directive' | 'poa';

export const LEGALZOOM_AFFILIATE_URLS: Record<EstateDocType, string> = {
  // TODO: replace with LegalZoom will affiliate link once approved
  will: PLACEHOLDER_FALLBACK,
  // TODO: replace with LegalZoom living-trust affiliate link once approved
  trust: PLACEHOLDER_FALLBACK,
  // TODO: replace with LegalZoom advance-directive affiliate link once approved
  advance_directive: PLACEHOLDER_FALLBACK,
  // TODO: replace with LegalZoom power-of-attorney affiliate link once approved
  poa: PLACEHOLDER_FALLBACK,
};

/**
 * True once real affiliate links are in place. Callers can use this to
 * hide the "Create one now" branch until the affiliate program is live.
 */
export const LEGALZOOM_AFFILIATE_ACTIVE = false;

export function getLegalZoomAffiliateUrl(docType: EstateDocType): string {
  return LEGALZOOM_AFFILIATE_URLS[docType] ?? PLACEHOLDER_FALLBACK;
}
